var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpwardCarat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 11",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8499 10.0349L9.40995 3.59488C9.20995 3.39488 8.89995 3.39488 8.69995 3.59488L2.26995 10.0349C2.17995 10.1249 2.04995 10.1849 1.91995 10.1849H0.499947C0.0499475 10.1849 -0.170052 9.64488 0.149947 9.33488L8.70995 0.774878C8.90995 0.574878 9.21995 0.574878 9.41995 0.774878L17.9799 9.33488C18.2899 9.64488 18.0699 10.1849 17.6299 10.1849H16.2199C16.0899 10.1849 15.9599 10.1349 15.8699 10.0349H15.8499Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpwardCarat);
export default __webpack_public_path__ + "static/media/UpwardCarat.aed71ac54c1c68d124984ef71ea5b0e0.svg";
export { ForwardRef as ReactComponent };